import Api from '@/helpers/api/index.js'

export const urlValidator = (url) => Api.post('/api/links/outreach/check-link', { url })
